import {
  HubspotServices as Hubspot,
  MarketoServices as Marketo,
  SalesforceServices as Salesforce,
  WebhookServices as Webhook,
} from '@clearkit/icons';

import { useHasOperationsAccess } from '../../../../hooks/account/usePlatformAccess';
import AddPlanPanel from './AddPlanPanel';
import styles from './styles';

function AddOperationsPlan({ classes }) {
  if (useHasOperationsAccess()) {
    return null;
  }

  let destinations = [
    {
      name: 'Webhook',
      description: 'Send data anywhere with Webhooks',
      icon: <Webhook className={classnames(classes.logo, 'text-green-500')} />,
    },
  ];

  return (
    <AddPlanPanel
      description="Get the context you need on every lead, contact and account your company cares about to power precise lead scoring and routing, rich customer segmentation, and reports that drive results."
      destinations={destinations}
      footerDescription="Also, write enriched data directly to your systems like Salesforce, Marketo, and Hubspot"
      footerIcons={[Salesforce, Marketo, Hubspot]}
      title="Accelerate Revenue"
    />
  );
}
export default withStyles(styles)(AddOperationsPlan);
